export function getLanguageCode(locale: string): string {
    return locale.split(/[_-]/)[0];
}
